import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Home from "./pages/home/Home";
import Whatwedo from "./pages/whatwedo/Whatwedo";
import Spices from "./pages/spices/Spices";
import Aata from "./pages/aata/Aata";
import Pickles from "./pages/pickles/Pickles";
import Salt from "./pages/salt/Salt";
import Dalia from "./pages/dalia/Dalia";
import Besan from "./pages/besan/Besan";
import Sooji from "./pages/sooji/Sooji";
import Maida from "./pages/maida/Maida";
import Aboutus from "./pages/aboutus/Aboutus";
import Content from "./pages/content/Content";
import Recipes from "./pages/recipes/Recipes";
import Privacy from "./pages/privacy/Privacy";
import Disclaimer from "./pages/privacy/Disclaimer";
import Support from "./pages/support/Support";
import Trainee from "./pages/trainee/Trainee";
import SingleTrainee from "./pages/trainee/SingleTrainee";

import Mixvegparatha from "./pages/recipes/recipe/mixvegparatha/Mixvegparatha";
import Maidavegpizzacones from "./pages/recipes/recipe/maidavegpizzacones/Maidavegpizzacones";
import Wholeattavegmomos from "./pages/recipes/recipe/wholeattavegmomos/Wholeattavegmomos";
import Wholeattacookies from "./pages/recipes/recipe/wholeattacookies/Wholeattacookies";
import Besanburfi from "./pages/recipes/recipe/besanburfi/Besanburfi";
import Soojidhokla from "./pages/recipes/recipe/soojidhokla/Soojidhokla";
import Sojivegcheela from "./pages/recipes/recipe/sojivegcheela/Sojivegcheela";
import Besankadhirice from "./pages/recipes/recipe/besankadhirice/Besankadhirice";
import Daliasalad from "./pages/recipes/recipe/daliasalad/Daliasalad";
import Daliakhichadi from "./pages/recipes/recipe/daliakhichadi/Daliakhichadi";
// import Nandimeatmasalacurry from "./pages/recipes/recipe/nandimeatmasalacurry/Nandimeatmasalacurry";
import Nandisabjimasala from "./pages/recipes/recipe/nandisabjimasala/Nandisabjimasala";
import Whatsapp from "./components/whatsapp/Whatsapp";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import ScrollButton from "./components/scroll/Scroll";
// import AOS from "aos";
// import "aos/dist/aos.css";

function App() {
  // useEffect(() => {
  //   AOS.init({
  //     duration: 1000,
  //     once: true,
  //     offset: 100, // Reduce this value
  //     anchorPlacement: "top-bottom", // Add this line
  //   });
  // }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <ScrollButton />
        <Whatsapp />
        <Routes>
          <Route path="/">
            <Route index element={<Home />} />
            <Route path="whatwedo" element={<Whatwedo />} />
            <Route path="spices" element={<Spices />} />
            <Route path="aata" element={<Aata />} />
            <Route path="pickles" element={<Pickles />} />
            <Route path="salt" element={<Salt />} />
            <Route path="dalia" element={<Dalia />} />
            <Route path="besan" element={<Besan />} />
            <Route path="sooji" element={<Sooji />} />
            <Route path="maida" element={<Maida />} />
            <Route path="aboutus" element={<Aboutus />} />
            <Route path="contactus" element={<Content />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="disclaimer" element={<Disclaimer />} />
            <Route path="support" element={<Support />} />
            <Route path="trainee" element={<Trainee />} />
            <Route path="trainee/:name" element={<SingleTrainee />} />
          </Route>

          <Route path="/recipes">
            <Route index element={<Recipes />} />
            <Route path="mixvegparatha" element={<Mixvegparatha />} />
            <Route path="besanburfi" element={<Besanburfi />} />
            <Route path="daliakhichadi" element={<Daliakhichadi />} />
            <Route path="maidavegpizzacones" element={<Maidavegpizzacones />} />
            <Route path="wholeattavegmomos" element={<Wholeattavegmomos />} />
            <Route path="wholeattacookies" element={<Wholeattacookies />} />
            <Route path="soojidhokla" element={<Soojidhokla />} />
            <Route path="sojivegcheela" element={<Sojivegcheela />} />
            <Route path="besankadhirice" element={<Besankadhirice />} />
            <Route path="daliasalad" element={<Daliasalad />} />
            <Route path="nandisabjimasala" element={<Nandisabjimasala />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
